<template>
    <div>
        <component v-for="(button,index) in buttons" :is="button._component" :button="button" :key="index" :step="step"></component>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";

export default {
    mixins: [mixin],
    data() {
        return {
            field_name:'gender',
            buttons:[
                // new Button('Homme', 'm').icon('/images/icons/male.png'),
                new Button('Monsieur', 'm'),
                new Button('Madame', 'f'),
            ]
        }
    },
    created() {
        this.step._field_name = this.field_name;
    }
}
</script>
